import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dw-rate" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["rate", {'cry': i <= _ctx.star && !_ctx.isSmile, 'smile': i <= _ctx.star && _ctx.isSmile}]),
        key: i,
        style: _normalizeStyle({width: `${_ctx.size}px`, height: `${_ctx.size}px`}),
        onClick: ($event: any) => (_ctx.onRate(i))
      }, null, 14, _hoisted_2))
    }), 128))
  ]))
}